'use client';

// Static podium medal PNGs (brand/decorative; same carve-out as hot-take flame / logo — FQ-IMG-003 allowlist).
import Image from 'next/image';

/** Static podium medals shipped under `/public/images/social/podium/`. */
const MEDAL_SRC: Record<1 | 2 | 3, string> = {
  1: '/images/social/podium/rank-1.png',
  2: '/images/social/podium/rank-2.png',
  3: '/images/social/podium/rank-3.png',
};

export interface PodiumRankMedalProps {
  rank: 1 | 2 | 3;
  /** Pass `''` when the medal is redundant for screen readers (e.g. decorative skeleton). */
  alt: string;
}

/**
 * Gold / silver / bronze medal in the top-right of the podium profile-card hero —
 * replaces the legacy hot-take flame glyph.
 */
export function PodiumRankMedal({ rank, alt }: PodiumRankMedalProps): React.ReactNode {
  return (
    <div className="pointer-events-none absolute top-2 right-2 bottom-2 z-10 aspect-square w-auto max-h-full">
      <Image
        src={MEDAL_SRC[rank]}
        alt={alt}
        fill
        priority={rank === 1}
        fetchPriority={rank === 1 ? 'high' : 'auto'}
        className="object-contain object-top-right drop-shadow-md"
        sizes="(max-width: 767px) 28vw, (max-width: 1023px) 100px, 120px"
      />
    </div>
  );
}
